import { render, staticRenderFns } from "./led_page.vue?vue&type=template&id=38ffcc42&scoped=true"
import script from "./led_page.vue?vue&type=script&lang=js"
export * from "./led_page.vue?vue&type=script&lang=js"
import style0 from "./led_page.vue?vue&type=style&index=0&id=38ffcc42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ffcc42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ffcc42')) {
      api.createRecord('38ffcc42', component.options)
    } else {
      api.reload('38ffcc42', component.options)
    }
    module.hot.accept("./led_page.vue?vue&type=template&id=38ffcc42&scoped=true", function () {
      api.rerender('38ffcc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/led/led_page.vue"
export default component.exports